import apiGetRequest from './base/api-get-request'

const getPublicDataHeatMap = (slug) => {
    return apiGetRequest(`/data-heatmap`)()
}

export default getPublicDataHeatMap